const MONTH_PARAM_PATTERN = /^\d{4}-(0[1-9]|1[0-2])$/;
const QUARTER_PARAM_PATTERN = /^\d{4}-Q[1-4]$/;

export function isValidMonthParam(value) {
  return MONTH_PARAM_PATTERN.test(value || '');
}

export function serializeMonth({ year, monthIndex }) {
  return `${year}-${String(monthIndex + 1).padStart(2, '0')}`;
}

export function parseMonthParam(value, fallback) {
  if (!isValidMonthParam(value)) return fallback;
  const [year, month] = value.split('-').map(Number);
  return { year, monthIndex: month - 1 };
}

export function isValidQuarterParam(value) {
  return QUARTER_PARAM_PATTERN.test(value || '');
}

export function serializeQuarter({ quarterYear, quarterIndex }) {
  return `${quarterYear}-Q${quarterIndex + 1}`;
}

export function parseQuarterParam(value, fallback) {
  if (!isValidQuarterParam(value)) return fallback;
  const [year, quarter] = value.split('-Q').map(Number);
  return { quarterYear: year, quarterIndex: quarter - 1 };
}
